export const LANGUAGES = {
  ENGLISH: 'en',
};
